var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTableListView(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Card_View_Icon",
    "data-name": "Card View Icon",
    d: "M15055.136,12871.471h-5.073a1.383,1.383,0,0,1-1.382-1.381v-5.083a1.381,1.381,0,0,1,1.382-1.378h5.073a1.381,1.381,0,0,1,1.384,1.378v5.083A1.383,1.383,0,0,1,15055.136,12871.471Zm-5.216-6.606v5.367h5.357v-5.367Zm-4.938,6.606h-5.076a1.385,1.385,0,0,1-1.386-1.381v-5.083a1.383,1.383,0,0,1,1.386-1.378h5.076a1.383,1.383,0,0,1,1.386,1.378v5.083A1.385,1.385,0,0,1,15044.981,12871.471Zm-5.218-6.606v5.367h5.359v-5.367Zm15.372-3.554h-5.073a1.382,1.382,0,0,1-1.382-1.379v-5.082a1.382,1.382,0,0,1,1.382-1.379h5.073a1.383,1.383,0,0,1,1.384,1.379v5.082A1.382,1.382,0,0,1,15055.136,12861.311Zm-5.216-6.6v5.365h5.357v-5.365Zm-4.938,6.6h-5.076a1.384,1.384,0,0,1-1.386-1.379v-5.082a1.385,1.385,0,0,1,1.386-1.379h5.076a1.385,1.385,0,0,1,1.386,1.379v5.082A1.384,1.384,0,0,1,15044.981,12861.311Zm-5.218-6.6v5.365h5.359v-5.365Z",
    transform: "translate(-15038.52 -12853.471)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableListView);
export default __webpack_public_path__ + "static/media/table-list-view.fe5897674ba940d2f42326e91bffcc49.svg";
export { ForwardRef as ReactComponent };